<template>
  <div class="home-selling-point">
    <div class="home-text">
      <div class="home-text-pos">
        <div class="swiper-container" id="home-text-pos">
          <div class="swiper-wrapper">
            <div class="swiper-slide soya-margin">
              <p class="home-text-title bold">
                {{ $t("home.bannerText0-title1") }}
              </p>
              <p class="home-text-title bold">
                {{ $t("home.bannerText0-title2") }}
              </p>
              <div class="home-text-margin">
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText0-content1") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText0-content2") }}
                </p>
                <img
                  src="@/assets/images/footerDao.png"
                  class="QRcode"
                  alt=""
                />
              </div>
            </div>
            <div class="swiper-slide soya-margin">
              <p class="home-text-title">{{ $t("home.bannerText1-title1") }}</p>
              <p class="home-text-title bold">
                {{ $t("home.bannerText1-title2") }}
              </p>
              <p class="home-text-title bold">
                {{ $t("home.bannerText1-title3") }}
              </p>
              <div class="home-text-margin soya-width">
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText1-content1") }}
                </p>
                <!-- <p class="home-text-normal bold">
                  {{ $t("home.bannerText1-content2") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText1-content3") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText1-content4") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText1-content5") }}
                </p> -->
              </div>
            </div>
            <!-- <div class="swiper-slide soya-margin">
              <p class="home-text-title bold">
                {{ $t("home.bannerText2-title1") }}
              </p>
              <p class="home-text-title bold">
                {{ $t("home.bannerText2-title2") }}
              </p>
              <p class="home-text-title">{{ $t("home.bannerText2-title3") }}</p>
              <div class="home-text-margin soya-width">
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText2-content1") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText2-content2") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText2-content3") }}
                </p>
                <p class="home-text-normal">
                  {{ $t("home.bannerText2-content4") }}
                </p>
                <p class="home-text-normal">
                  {{ $t("home.bannerText2-content5") }}
                </p>
              </div>
            </div> -->
            <!-- <div class="swiper-slide soya-margin">
              <p class="home-text-title bold">
                {{ $t("home.bannerText3-title1") }}
              </p>
              <p class="home-text-title">{{ $t("home.bannerText3-title2") }}</p>
              <p class="home-text-title">{{ $t("home.bannerText3-title3") }}</p>
              <div class="home-text-margin soya-width">
                <p class="home-text-normal">
                  {{ $t("home.bannerText3-content1") }}
                </p>
                <p class="home-text-normal">
                  {{ $t("home.bannerText3-content2") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText3-content3") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText3-content4") }}
                </p>
              </div>
            </div> -->
            <div class="swiper-slide soya-margin">
              <p class="home-text-title">{{ $t("home.bannerText4-title1") }}</p>
              <p class="home-text-title bold">
                {{ $t("home.bannerText4-title2") }}
              </p>
              <div class="home-text-margin soya-width">
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText4-content1") }}
                </p>
                <p class="home-text-normal bold">
                  {{ $t("home.bannerText4-content2") }}
                </p>
                <p class="home-text-normal">
                  {{ $t("home.bannerText4-content3") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <img
          src="@/assets/images/right.png"
          @click="swiperNext"
          @mouseover="swiperMouseIn"
          @mouseleave="swiperMouseOutFun"
          class="img_right"
          alt=""
        />
      </div>
    </div>
    <div class="home-pic">
      <div class="orange-box"></div>
      <div class="swiper-container" id="home-pic">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img
              src="@/assets/images/home-selling-point0.png"
              alt=""
              class="home-pic-banner"
            />
          </div>
          <div class="swiper-slide">
            <img
              src="@/assets/images/home-selling-point1.png"
              alt=""
              class="home-pic-banner"
            />
          </div>
          <!-- <div class="swiper-slide">
            <img
              src="@/assets/images/home-selling-point2.jpg"
              alt=""
              class="home-pic-banner"
            />
          </div> -->
          <!-- <div class="swiper-slide">
            <img
              src="@/assets/images/home-selling-point3.png"
              alt=""
              class="home-pic-banner"
            />
          </div> -->
          <div class="swiper-slide">
            <img
              src="@/assets/images/home-selling-point4.png"
              alt=""
              class="home-pic-banner"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      swiper1: null,
      swiper2: null,
    };
  },
  mounted() {
    this.swiperInit();
  },
  methods: {
    swiperInit() {
      this.swiper2 = new Swiper("#home-pic", {
        speed: 700,
        loop: true,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      });
      this.swiper1 = new Swiper("#home-text-pos", {
        speed: 700,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          pauseOnMouseEnter: true,
          delay: 5000,
          disableOnInteraction: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      });

      //6.6.2之前的版本需要通过代码实现此功能
      // var _this = this;
      // this.swiper2.el.onmouseover = function () {
      //   _this.swiper2.autoplay.stop();
      // };
      // this.swiper2.el.onmouseout = function () {
      //   _this.swiper2.autoplay.start();
      // };
      this.swiper1.controller.control = this.swiper2; //Swiper1控制Swiper2，需要在Swiper2初始化后
      this.swiper2.controller.control = this.swiper1; //Swiper2控制Swiper1，需要在Swiper1初始化后
    },
    swiperNext() {
      // this.swiper1.autoplay.stop();
      // this.swiper2.autoplay.stop();
      this.swiper1.slideNext();
    },
    swiperMouseOutFun() {
      console.log("MouseOut");
      // this.swiper1.autoplay.start();
      // this.swiper2.autoplay.start();
      // this.swiper1.slideNext();
      this.swiper1.autoplay.start();
    },
    swiperMouseIn() {
      console.log("MouseIn");
      this.swiper1.autoplay.stop();
    },
  },
};
</script>

<style lang="scss" scoped>
.soya-width {
  width: 500px;
}
#home-text-pos {
  .swiper-slide {
    background-color: #c6e7fb;
  }
}
#home-pic {
  position: relative;
  width: 82%;
  float: left;
  margin-bottom: 50px;
  z-index: 2;
  &.swiper-container {
    height: auto !important;
    .swiper-slide {
      > img {
        display: block;
        width: 100%;
      }
    }
  }
  @media (max-width: 768px) {
    position: relative;
    width: 90%;
    margin: 5% 0 15% 5%;
  }
}
.home-text-title {
  font-size: 44px;
  line-height: 60px;
  color: #3e3e3e;
}
.home-text-normal {
  font-size: 20px;
  color: #404040;
  line-height: 30px;
}
.home-text-margin {
  margin: 50px 0;
}
.home-text-pos {
  position: absolute;
  top: 5px;
  left: 17%;
}

.home-selling-point {
  padding: 80px 0 0 0;
  display: flex;
  //   min-height: 1000px;
  background: #c6e7fb;
  overflow: hidden;
  border: 1px solid #000;
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  border-right: 1px solid #000;

  .home-text {
    width: 47%;
    text-align: left;
    position: relative;
  }
  .home-pic {
    position: relative;
    width: 53%;
  }
}
// .home-pic-banner {
//   position: relative;
//   width: 82%;
//   float: left;
//   margin-bottom: 30%;
//   z-index: 2;
// }
.orange-box {
  width: 100%;
  height: 60%;
  background: #ff8a3b;
  position: absolute;
  bottom: 0;
  right: 0%;
  z-index: 1;
  border-top: 1px solid #000;
  border-left: 1px solid #000;
}
.img_right {
  position: absolute;
  bottom: -30px;
  left: 20px;
  width: 56px;
  cursor: pointer;
  z-index: 999;
}
.text-margin {
  margin-top: 50px;
}
.QRcode {
  width: 170px;
  margin-top: 30px;
}
@media (max-width: 1450px) {
  .home-text-title {
    font-size: 44px;
    line-height: 60px;
    color: #3e3e3e;
  }
  .home-text-normal {
    font-size: 20px;
    color: #404040;
  }
  .home-text-pos {
    position: absolute;
    left: 10%;
  }
  .img_right {
    position: absolute;
    bottom: -30px;
    left: 20px;
    width: 50px;
  }
}
@media (max-width: 1350px) {
  .soya-width {
    width: 470px;
  }
  .home-text-title {
    font-size: 42px;
    line-height: 50px;
    color: #3e3e3e;
  }
  .home-text-normal {
    font-size: 18px;
    color: #404040;
  }
  .home-text-pos {
    position: absolute;
    left: 10%;
  }
}
@media (max-width: 1200px) {
  .soya-width {
    width: 450px;
  }
  .home-text-title {
    font-size: 40px;
    line-height: 50px;
    color: #3e3e3e;
  }
  .home-text-normal {
    font-size: 18px;
    color: #404040;
  }
  .home-text-pos {
    position: absolute;
    left: 10%;
  }
  .img_right {
    position: absolute;
    bottom: -30px;
    left: 20px;
    width: 40px;
    cursor: pointer;
    z-index: 999;
  }
}
@media (max-width: 768px) {
  .QRcode {
    width: 90px;
    margin-top: 20px;
  }
  .soya-width {
    width: 100%;
  }
  .home-selling-point {
    padding: 20px 0 0 0;
    display: block;
    background: #c6e7fb;
    overflow: hidden;
    .home-text {
      width: 100%;
      padding: 20px;
      text-align: left;
      position: relative;
    }
    .home-pic {
      position: relative;
      width: 100%;
      overflow: hidden;
    }
  }
  .home-text-title {
    font-size: 38px;
    line-height: 40px;
    color: #3e3e3e;
  }
  .home-text-normal {
    font-size: 14px;
    line-height: 25px;
    color: #404040;
  }
  .home-text-margin {
    margin: 20px 0;
  }
  .home-text-pos {
    position: relative;
    left: 0;
  }
  .orange-box {
    width: 90%;
  }
  // .home-pic-banner {
  //   position: relative;
  //   width: 90%;
  //   margin: 0 0 20% 5%;
  // }
  .text-margin {
    margin-top: 20px;
  }
  .img_right {
    position: absolute;
    bottom: -15px;
    left: 0px;
    width: 30px;
    cursor: pointer;
    z-index: 999;
  }
}
</style>